/// <reference path="../_references.ts"/>
module App.Timeclock {
	import LocationService = App.Helpers.LocationService;

	type TimeclockListener = (timeclock: Timeclock) => void;

	export class TimeclockService {
		private static listeners: TimeclockListener[] = [];
		static factory() {
			let instance = ($http: ng.IHttpService, Constants: IConstants, LocationService: LocationService) =>
				new TimeclockService($http, Constants, LocationService);

			instance.$inject = ['$http', 'Constants', 'LocationService'];

			return instance;
		}

		public static addListener(listener: TimeclockListener) {
			this.listeners.push(listener);
		}

		public static removeListener(listener: TimeclockListener) {
			var index: number;
			while((index = this.listeners.indexOf(listener)) >= 0) {
				this.listeners.splice(index, 1);
			}
		}

		private static notify(timeclock: Timeclock) {
			this.listeners.forEach(function(listener: TimeclockListener) { listener(timeclock); });
		}

		constructor(
			public $http: ng.IHttpService,
			public Constants: IConstants,
			public LocationService: LocationService
		){ }

		public fetchAll(techId: number, params?: object): ng.IPromise<Timeclock[]> {
			return this.$http.get(`${this.Constants.apiUrl}technician/${techId}/timeclock`, {
				params: params || {},
			}).then((response: ng.IHttpResponse<Timeclock[]>) => {
				const timeclocks = (response && response.data) || [];

				timeclocks.forEach((timeclock: Timeclock) => {
					TimeclockService.notify(timeclock);
				});

				return timeclocks;
			});
		}

		public update(techId:number, timeclock: Timeclock): ng.IPromise<Timeclock> {
			return this.LocationService.getLocation().then((coords) => {
				let data: any = timeclock;
				data.latitude = coords.latitude;
				data.longitude = coords.longitude;

				return this.$http.put(`${this.Constants.apiUrl}technician/${techId}/timeclock/${timeclock.id}`, data).then((response: ng.IHttpResponse<Timeclock>) => {
					let timeclock = response.data;
					TimeclockService.notify(timeclock);
					return timeclock;
				});
			});
		}

		public clockIn(techId: number): ng.IPromise<Timeclock> {
			return this.LocationService.getLocation().then((coords) => {
				return this.$http.post(`${this.Constants.apiUrl}technician/${techId}/timeclock/clockin`, {
					latitude: coords.latitude,
					longitude: coords.longitude
				}).then((response: ng.IHttpResponse<Timeclock>) => {
					let timeclock = response.data;
					TimeclockService.notify(timeclock);
					return timeclock;
				});
			});
		}

		public clockOut(techId: number): ng.IPromise<Timeclock> {
			return this.LocationService.getLocation().then((coords) => {
				return this.$http.put(`${this.Constants.apiUrl}technician/${techId}/timeclock/clockout`, {
					latitude: coords.latitude,
					longitude: coords.longitude
				}).then((response: ng.IHttpResponse<Timeclock>) => {
					let timeclock = response.data;
					TimeclockService.notify(timeclock);
					return timeclock;
				});
			});
		}
	}
}
